
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12754',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12754",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.481",
  "data-fetching-client": "static-1.9780",
  "foundations-components": "static-1.8175",
  "foundations-components-legacy": "static-1.1200",
  "foundations-theming": "static-1.4551",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8139",
  "hub-http-shared-msw-handlers": "static-1.10261",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11590",
  "I18n": "static-7.1639",
  "jasmine-runner": "static-1.6577",
  "marketplace-storefront-base": "static-1.12817",
  "quartz": "static-1.7183",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16803",
  "reactive-variable-buffer-atom": "static-1.2976",
  "reporting-testing-lib": "static-1.9988",
  "settings-ui-lib": "static-1.12640",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7358",
  "ui-addon-i18n": "static-1.11267",
  "ui-addon-react-router-dom": "static-1.9656",
  "unified-auth": "static-1.636",
  "unified-auth-core-lib": "static-1.918",
  "usage-tracker": "static-1.7467",
  "usage-tracker-core": "static-1.7317",
  "customer-data-property-utils": "static-1.8214",
  "hub-http": "static-1.6342",
  "integrations-lib": "static-1.16535",
  "marketplace-ui-common": "static-1.20166",
  "property-management-iframe": "static-1.13565",
  "quartz-config": "static-1.961",
  "quartz-core": "static-1.6402",
  "quartz-routing": "static-1.613",
  "quick-fetch": "static-1.4005",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4776",
  "ts-schema": "static-1.4169",
  "ui-universal-auth": "static-1.9122",
  "UIComponents": "static-3.8536",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3485",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3460",
  "quartz-webpack": "static-1.3407",
  "bend-plugin-quartz-routing": "static-1.261",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4444",
  "floating-ui": "static-1.58",
  "foundations-assets": "static-1.4992",
  "foundations-theming-specialty": "static-1.2267",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9542",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.37",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5429",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2198",
  "ui-fonts": "static-1.852",
  "ui-images": "static-2.1184",
  "bend-plugin-foundations-theming": "static-1.3034",
  "foundations-theming-base": "static-1.3536",
  "stylex": "static-1.35",
  "HeadJS": "static-2.771",
  "hs-test-utils-bend-plugin": "static-1.3250",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4445",
  "ai-components-ui-library": "static-1.9259",
  "ai-rendering-library": "static-1.10605",
  "chirp-fetch": "static-1.2007",
  "connections-embed-lib": "static-1.1221",
  "copilot-toolkit": "static-1.11440",
  "feedback-loader": "static-1.29526",
  "laboratory-lib": "static-3.7272",
  "marketplace-embed": "static-1.22464",
  "marketplace-ui-details": "static-1.10061",
  "marketplace-ui-reviews": "static-1.20121",
  "marketplace-ui-tracking": "static-1.14336",
  "sanitize-text": "static-1.8264",
  "ui-addon-video-player": "static-1.8823",
  "usage-tracker-multi": "static-1.5881",
  "usage-tracker-session-replay": "static-1.5153",
  "wootric-nps": "static-1.7070",
  "quartz-head": "static-1.848",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4770",
  "immer": "static-1.33",
  "immerable": "static-1.4269",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2570",
  "reporting-data": "static-1.68055",
  "cssUtils": "static-1.826",
  "flux-actions": "static-1.346",
  "HubStyle": "static-2.11897",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10326",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10481",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7457",
  "icons": "static-2.654",
  "marketplace-ui-apps-core": "static-1.18698",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4630",
  "foundations-components-test-utils": "static-1.5658",
  "quartz-i18n": "static-1.858",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.26",
  "ads-unified-auth-lib": "static-1.397",
  "google-sheets-integration-lib": "static-1.590",
  "microsoft-drive-integration-lib": "static-1.729",
  "surveymonkey-integration-lib": "static-1.46",
  "slack-ui-library": "static-1.10515",
  "fsm": "static-1.3848",
  "customer-data-objects": "static-1.7798",
  "property-translator": "static-1.5516",
  "hs-locale-management": "static-1.169",
  "frontend-preferences-client": "static-1.8045",
  "hs-promise-utils": "static-1.5712",
  "hubspot-apollo-client": "static-1.4997",
  "integrations-error-boundary-lib": "static-1.13950",
  "integrations-tracking-lib": "static-1.5725",
  "native-integrations-shared-strings": "static-1.7900",
  "reselect": "static-2.16",
  "sanitize": "static-1.4595",
  "superstore": "static-1.4878",
  "ui-shepherd-react": "static-3.10370",
  "ai-settings-ui-library": "static-1.8082",
  "hub-http-janus": "static-1.846",
  "hubspotter-http": "static-1.4738",
  "immutable-less": "static-1.4772",
  "marketplace-ui-client-types": "static-1.17573",
  "nav-meta": "static-1.29943",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18158",
  "inbound-db-properties-service-client": "static-1.3934",
  "property-management-common": "static-1.5853",
  "ui-addon-iframeable": "static-1.9186",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.545",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.858",
  "quartz-test": "static-1.858",
  "quartz-tracking": "static-1.562",
  "trellis-components": "static-1.2217",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.186",
  "bender-build-tools": "static-1.3297",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21866",
  "ContentUtils": "static-1.68715",
  "customer-data-objects-ui-components": "static-1.13148",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2616",
  "breeze-engine-core": "static-1.412",
  "breeze-onboarding-components": "static-1.263",
  "customer-data-filters-ui": "static-1.40216",
  "customer-data-reference-ui-components": "static-1.13293",
  "embedded-academy-lib": "static-1.14764",
  "ExportDialog": "static-6.10499",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41608",
  "reporting-snowflake": "static-1.56673",
  "reporting-ui-components": "static-2.65326",
  "reporting-visualizations": "static-1.60131",
  "trellis-theming": "static-1.1060",
  "ui-addon-teams": "static-1.21706",
  "integrations-reconnect-lib": "static-1.194",
  "magpie-lib": "static-1.5630",
  "navigation-components": "static-1.18306",
  "breeze-engine-lib": "static-1.1134",
  "magpie-types": "static-1.5090",
  "simple-logging-lib": "static-1.3168",
  "ai-studio-lib": "static-1.11968",
  "app-governance-lib": "static-1.1931",
  "developer-experience-shared-components": "static-1.10632",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8127",
  "ui-product-approvals": "static-1.28633",
  "ui-tool-access": "static-1.10267",
  "usage-based-billing-components-lib": "static-1.9442",
  "usage-tracker-anonymous": "static-1.5884",
  "usage-tracker-public": "static-1.7278",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3674",
  "persist-promise": "static-1.3819",
  "reference-resolvers": "static-1.8294",
  "ui-extensibility-client-types": "static-1.4043",
  "hubspot-apollo-cache": "static-1.456",
  "universal-page-editor-lib": "static-1.3133",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3113",
  "atom": "static-1.5194",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6099",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1662",
  "crm-component-utils": "static-1.39394",
  "crm-properties-common-lib": "static-1.6009",
  "customer-data-properties": "static-1.51977",
  "framework-data-schema-resolvers": "static-1.7013",
  "property-value-citations": "static-1.2591",
  "reference-resolvers-lite": "static-1.8216",
  "ui-business-units-lib": "static-1.9186",
  "navigation-messaging": "static-1.7633",
  "hubspotter-http-shared-msw-handlers": "static-1.10259",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4934",
  "content-icons-ui": "static-1.2260",
  "customer-data-ui-utilities": "static-1.9944",
  "conversations-skeleton-state": "static-1.7366",
  "crm-message-bus": "static-1.43297",
  "customer-data-filters-ui-msw-helpers": "static-1.22651",
  "events-data-lib": "static-1.352",
  "FormUrlGenerator": "static-2.4840",
  "framework-builder-read-service-client": "static-1.4091",
  "framework-data-schema-quick-fetch": "static-1.6918",
  "multi-account-reference-resolvers": "static-1.1100",
  "onboarding-tours": "static-1.16831",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14023",
  "academy-common-lib": "static-1.14224",
  "content-assistance-lib": "static-1.7948",
  "dashboard-lib": "static-1.82001",
  "file-manager-components": "static-1.23961",
  "getting-started-shared-tasks": "static-1.18745",
  "hubspot-prosemirror": "static-1.18583",
  "hubspot-prosemirror-plugins": "static-1.18575",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20043",
  "share-with-third-party-component-lib": "static-1.8823",
  "ui-addon-draggable": "static-3.4878",
  "ui-asset-management-lib": "static-1.11186",
  "user-context": "static-1.5228",
  "growth-payments-core": "static-1.25729",
  "reporting-plugins": "static-1.10512",
  "reporting-reports": "static-1.67733",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.845",
  "nest": "static-1.351",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10746",
  "framework-listing-lib": "static-2.29030",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30986",
  "apps-service-types": "static-1.3919",
  "oauth-service-types": "static-1.4372",
  "react-dnd-compat": "static-1.4733",
  "ui-product-approvals-common": "static-1.528",
  "onboarding-scopes": "static-1.6579",
  "onboarding-tours-client": "static-1.5045",
  "platform-infra-nav-components": "static-1.7761",
  "subscription-experience-data-types": "static-1.15069",
  "crm-record-cards-service-types": "static-1.3673",
  "location-customization-utils-lib": "static-1.9604",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6102",
  "signup-constants": "static-1.19140",
  "signup-ui-url-generator": "static-2.8176",
  "card-properties-lib": "static-1.44550",
  "commerce-subscription-lib": "static-1.37422",
  "crm-actions": "static-1.6459",
  "crm-cards-sdk": "static-1.43950",
  "customer-data-properties-shared-msw-handlers": "static-1.9588",
  "customer-data-tracking": "static-1.7006",
  "hs-resources": "static-1.294",
  "pulse": "static-1.723",
  "calling-global-api": "static-1.64921",
  "calling-internal-common": "static-1.31429",
  "calling-lifecycle-internal": "static-1.66303",
  "calling-lifecycle-messages": "static-1.58597",
  "commerce-products-lib": "static-1.10008",
  "conditional-properties-service-client": "static-1.3885",
  "crm-links": "static-1.6426",
  "crm-pipelines-api-client-types": "static-1.4224",
  "external-options-client-types": "static-1.4214",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4305",
  "meetings-icalendar-utils-lib": "static-1.752",
  "multi-currency-client-types": "static-1.3778",
  "object-builder-ui-client": "static-1.49157",
  "pipeline-validation-client-types": "static-1.4053",
  "smart-property-lib": "static-1.7850",
  "tiered-pricing": "static-1.1533",
  "ui-addon-form-validation": "static-1.11109",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.132",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1175",
  "growth-data-modal": "static-1.5626",
  "growth-onboarding-confetti": "static-1.3184",
  "growth-onboarding-next-action-utils": "static-1.2261",
  "onboarding-tours-utils": "static-1.897",
  "ui-shepherd-tracker": "static-1.7751",
  "academy-service-client": "static-1.3803",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39460",
  "FileManagerLib": "static-1.39601",
  "SafeStorage": "static-1.4517",
  "video-embed": "static-1.36158",
  "ui-coaching-tips": "static-1.28891",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11666",
  "video-data-lib": "static-1.35324",
  "content-media-capture": "static-1.4877",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23831",
  "ui-addon-emoji-picker": "static-1.10006",
  "EmailSignatureEditor": "static-1.24640",
  "viral-links-lib": "static-1.7187",
  "data-token-picker": "static-1.16625",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.349",
  "timezone-utils": "static-2.5362",
  "seat-types-lib": "static-1.280",
  "getting-started-shared-tasks-store": "static-1.17863",
  "ui-addon-opt": "static-4.8480",
  "campaign-roi-lib": "static-1.9454",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25692",
  "framework-data-table": "static-2.12193",
  "marketing-platform-lib": "static-1.6984",
  "nudge-client-utils": "static-1.2838",
  "nudge-custom-ui-functions": "static-1.1241",
  "switchboard-lib": "static-1.342",
  "app-users-service-client": "static-1.5728",
  "app-users-service-types": "static-1.5136",
  "mini-checkout-client": "static-1.27101",
  "onboarding-utils": "static-1.5477",
  "permissions-shared-i18n-strings-fe": "static-1.2062",
  "ui-coaching-tips-shared-config": "static-1.28876",
  "edison-service-client-types": "static-1.508",
  "crm_data": "static-4.92344",
  "customer-data-sidebar": "static-2.46345",
  "enrichment-properties-lib": "static-1.16968",
  "ui-addon-draggable-compat": "static-2.4379",
  "universal-record-utils-lib": "static-1.1263",
  "commerce-billing-lib": "static-1.19481",
  "commerce-shared-components-lib": "static-1.18834",
  "commerce-tools-ui-lib": "static-1.10695",
  "crm-fe-perf": "static-1.23021",
  "event-emitter": "static-1.1068",
  "bend-plugin-pulse": "static-1.226",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31436",
  "shared-worker-versioning": "static-1.11154",
  "calling-usage-tracker": "static-1.6662",
  "voice-sms-access-library": "static-1.1450",
  "commerce-permissions": "static-1.895",
  "products-iframe-lib": "static-1.8262",
  "products-ui-components-shared-msw-handlers": "static-1.10643",
  "data-agent-kit": "static-1.399",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10344",
  "policy-lib": "static-1.6904",
  "react-tinymce": "static-1.55561",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10407",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54687",
  "tinymce-plugins": "static-1.57801",
  "tinymce-themes": "static-1.56657",
  "onboarding-data-sync-lib": "static-1.2173",
  "growth-onboarding-next-action-components": "static-1.2289",
  "user-context-client": "static-1.4698",
  "audio-components": "static-1.6104",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37112",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4655",
  "video-components": "static-1.13668",
  "outpost": "static-1.4287",
  "growth-onboarding-feedback-components": "static-1.6697",
  "content-media-composition-data-lib": "static-1.12681",
  "content-media-compositions": "static-2.16688",
  "media-bridge-lib": "static-1.19138",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4544",
  "commerce-tours-lib": "static-1.6324",
  "growth-onboarding-reliability": "static-1.5200",
  "sales-checkout-service-client": "static-1.3712",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21891",
  "sales-email-signature-service-client": "static-1.3969",
  "ts-utils-lib": "static-1.292",
  "crm-export-dialog": "static-1.6404",
  "crm-index-associations-lib": "static-1.6560",
  "crm-view-components": "static-1.636",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7450",
  "nudge-custom-function-registry": "static-1.2595",
  "nudge-renderer-utils": "static-1.2914",
  "whisper-core-api": "static-1.6876",
  "InboxConnectUtils": "static-4.15126",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5812",
  "settings-content-modals": "static-1.46420",
  "crm_universal": "static-1.22226",
  "customer-data-email": "static-1.18252",
  "card-payment-highlight-lib": "static-1.37516",
  "card-subscription-highlight-lib": "static-1.39845",
  "commerce-contract-lib": "static-1.12641",
  "invoices-highlight-card-lib": "static-1.55118",
  "orders-highlight-card-lib": "static-1.21792",
  "products-highlight-card-lib": "static-1.18291",
  "quotes-highlight-card-lib": "static-1.72419",
  "crm-source-interpretation-lib": "static-1.5459",
  "crm-object-search-query-utilities": "static-1.9856",
  "utility-belt": "static-1.2650",
  "payments-enrollment-embed-lib": "static-1.23268",
  "stripe-embedded-components": "static-1.7726",
  "customer-data-rte": "static-1.33310",
  "cv-backend-services": "static-1.1561",
  "growth-onboarding-empty-states": "static-1.5966",
  "payments-post-enroll-local-storage-lib": "static-1.5225",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38509",
  "trials-service-types": "static-1.4002",
  "calling-orchestration-schema": "static-1.36227",
  "sales-views-client-types": "static-1.4376",
  "hub-http-contrib": "static-1.3162",
  "interframe": "static-3.4879",
  "tinymce-data": "static-1.40772",
  "ui-addon-sales-email": "static-1.5329",
  "layout-dnd-components": "static-1.12682",
  "layout-dnd-utils": "static-1.11657",
  "ui-brand-identity-lib": "static-1.15714",
  "NamespacedHubStyle": "static-2.9141",
  "meetings-connect-utils-lib": "static-1.7724",
  "social-insights-client-types": "static-1.22353",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4293",
  "checkout-sdk": "static-3.23944",
  "company-details-components": "static-1.6317",
  "payment-method-components": "static-1.6988",
  "pricing-pages-ui-components": "static-1.14732",
  "quote-checkout-service-types": "static-1.3583",
  "upgrade-catalog-service-types": "static-1.3641",
  "access-control-lib": "static-1.10555",
  "EmailComponents": "static-1.55102",
  "EmailData": "static-1.53779",
  "redux-less": "static-2.9601",
  "sequences-lib": "static-1.8247",
  "ui-gdpr-components": "static-1.10469",
  "products-ui-components": "static-1.40526",
  "accounting-integrations-ui-components": "static-1.7265",
  "invoices-ui-lib": "static-1.55134",
  "commerce-products-api": "static-1.2471",
  "invoices-iframe-lib": "static-1.57192",
  "quotes-modal-lib": "static-1.103097",
  "quotes-ui-lib": "static-1.81140",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28576",
  "ContentData": "static-1.68790",
  "layout-data-lib": "static-1.9982",
  "checkout-service-types": "static-1.3884",
  "hub-http-rxjs": "static-1.812",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4056",
  "billing-payments-client-types": "static-1.4109",
  "react-performance-metrics-lib": "static-1.676",
  "pricing-pages-api": "static-1.14597",
  "ContentComponents": "static-2.71671",
  "marketing-contacts-lib": "static-1.10439",
  "marketing-email-service-types": "static-1.1988",
  "messaging-editing-lib": "static-1.46620",
  "messaging-usage-based-billing-components-lib": "static-1.1482",
  "automation-ui-source-apps": "static-1.19230",
  "automation-ui-types": "static-1.20148",
  "messaging-types-lib": "static-1.46357",
  "onboarding-settings-client": "static-1.4623",
  "sequences-client-types-lib": "static-1.8104",
  "commerce-tax-lib": "static-1.654",
  "price-books-api": "static-1.1254",
  "price-books-components": "static-1.1312",
  "property-description-translator": "static-1.3960",
  "ramp-editor": "static-1.467",
  "commerce-analytics-service-client": "static-1.3700",
  "totals-ui-components": "static-1.23922",
  "SalesContentIndexUI": "static-3.9410",
  "advanced-menus-core": "static-1.15332",
  "advanced-menus-lib": "static-1.12243",
  "ui-memberships-settings-lib": "static-1.34364",
  "segments-query-core": "static-1.1539",
  "automation-ui-ubb": "static-1.6064",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7457",
  "data-token-views": "static-1.16606",
  "forms-utils-lib": "static-1.12811",
  "payments-embed-points-lib": "static-1.13279",
  "simple-menus-core": "static-1.15331",
  "simple-menus-lib": "static-1.16848",
  "videoconference-integration-components": "static-1.7004",
  "mc-hard-limits-client-types": "static-1.16",
  "marketing-contacts-client": "static-1.7630",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77435",
  "short-messages-app-service-client": "static-1.4042",
  "web-interactives-components": "static-1.13976",
  "web-interactives-data": "static-1.13977",
  "messaging-shared-utils-lib": "static-1.931",
  "messaging-user-info-utils-lib": "static-1.1101",
  "email-portal-health-service-types": "static-1.1096",
  "line-items-api": "static-1.869",
  "commerce-totals-service-types": "static-1.3905",
  "FireAlarmUi": "static-1.4595",
  "sales-templates-service-types-lib": "static-1.4256",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22084",
  "automation-ui-usage-tracking": "static-1.21547",
  "data-studio-ubb": "static-1.3067",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27294",
  "collaboration-sidebar": "static-1.58199",
  "content-management-data-lib": "static-1.5619",
  "copilot-plugins": "static-1.11413",
  "cta-picker": "static-1.36714",
  "customer-agent-discovery-components-lib": "static-1.3427",
  "editor-components": "static-1.13407",
  "editor-iframe-lib": "static-1.8574",
  "error-messaging-js": "static-1.5312",
  "FormsCommonComponents": "static-1.86138",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10765",
  "SharedLegalStrings": "static-1.1863",
  "smart-content-core": "static-1.42768",
  "smart-content-lib": "static-1.43421",
  "social-composer-lib": "static-1.59577",
  "structured-content-lib": "static-1.25510",
  "theme-previewer-lib": "static-1.53570",
  "tinymce-copilot": "static-1.16755",
  "xray-recommendation-lib": "static-1.8061",
  "automation-ui-routing": "static-1.21505",
  "sql-reporting-client-types": "static-1.5733",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42458",
  "campaigns-utils-lib": "static-1.3311",
  "reporting-enablement": "static-1.23332",
  "chatspot-widget-iframe": "static-1.21857",
  "collaboration-sidebar-common": "static-1.2996",
  "forms-ai-lib": "static-1.4509",
  "codemirror-dlb": "static-1.58994",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6554",
  "report-customization-components": "static-1.13499",
  "data-quality-ui-library": "static-1.13345",
  "reporting-filters": "static-1.620",
  "reporting-insights-lib": "static-1.2095"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12754",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.481",
  "data-fetching-client": "/data-fetching-client/static-1.9780",
  "foundations-components": "/foundations-components/static-1.8175",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1200",
  "foundations-theming": "/foundations-theming/static-1.4551",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8139",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10261",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11590",
  "I18n": "/I18n/static-7.1639",
  "jasmine-runner": "/jasmine-runner/static-1.6577",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12817",
  "quartz": "/quartz/static-1.7183",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16803",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2976",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9988",
  "settings-ui-lib": "/settings-ui-lib/static-1.12640",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7358",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11267",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9656",
  "unified-auth": "/unified-auth/static-1.636",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.918",
  "usage-tracker": "/usage-tracker/static-1.7467",
  "usage-tracker-core": "/usage-tracker-core/static-1.7317",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8214",
  "hub-http": "/hub-http/static-1.6342",
  "integrations-lib": "/integrations-lib/static-1.16535",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20166",
  "property-management-iframe": "/property-management-iframe/static-1.13565",
  "quartz-config": "/quartz-config/static-1.961",
  "quartz-core": "/quartz-core/static-1.6402",
  "quartz-routing": "/quartz-routing/static-1.613",
  "quick-fetch": "/quick-fetch/static-1.4005",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4776",
  "ts-schema": "/ts-schema/static-1.4169",
  "ui-universal-auth": "/ui-universal-auth/static-1.9122",
  "UIComponents": "/UIComponents/static-3.8536",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3485",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3460",
  "quartz-webpack": "/quartz-webpack/static-1.3407",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.261",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4444",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4992",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2267",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9542",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.37",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5429",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2198",
  "ui-fonts": "/ui-fonts/static-1.852",
  "ui-images": "/ui-images/static-2.1184",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3034",
  "foundations-theming-base": "/foundations-theming-base/static-1.3536",
  "stylex": "/stylex/static-1.35",
  "HeadJS": "/HeadJS/static-2.771",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3250",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4445",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9259",
  "ai-rendering-library": "/ai-rendering-library/static-1.10605",
  "chirp-fetch": "/chirp-fetch/static-1.2007",
  "connections-embed-lib": "/connections-embed-lib/static-1.1221",
  "copilot-toolkit": "/copilot-toolkit/static-1.11440",
  "feedback-loader": "/feedback-loader/static-1.29526",
  "laboratory-lib": "/laboratory-lib/static-3.7272",
  "marketplace-embed": "/marketplace-embed/static-1.22464",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10061",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20121",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14336",
  "sanitize-text": "/sanitize-text/static-1.8264",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8823",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5881",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5153",
  "wootric-nps": "/wootric-nps/static-1.7070",
  "quartz-head": "/quartz-head/static-1.848",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4770",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4269",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2570",
  "reporting-data": "/reporting-data/static-1.68055",
  "cssUtils": "/cssUtils/static-1.826",
  "flux-actions": "/flux-actions/static-1.346",
  "HubStyle": "/HubStyle/static-2.11897",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10326",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10481",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7457",
  "icons": "/icons/static-2.654",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18698",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4630",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5658",
  "quartz-i18n": "/quartz-i18n/static-1.858",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.26",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.397",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.590",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.729",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.46",
  "slack-ui-library": "/slack-ui-library/static-1.10515",
  "fsm": "/fsm/static-1.3848",
  "customer-data-objects": "/customer-data-objects/static-1.7798",
  "property-translator": "/property-translator/static-1.5516",
  "hs-locale-management": "/hs-locale-management/static-1.169",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8045",
  "hs-promise-utils": "/hs-promise-utils/static-1.5712",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4997",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13950",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5725",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7900",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4595",
  "superstore": "/superstore/static-1.4878",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10370",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8082",
  "hub-http-janus": "/hub-http-janus/static-1.846",
  "hubspotter-http": "/hubspotter-http/static-1.4738",
  "immutable-less": "/immutable-less/static-1.4772",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17573",
  "nav-meta": "/nav-meta/static-1.29943",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18158",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3934",
  "property-management-common": "/property-management-common/static-1.5853",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9186",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.545",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.858",
  "quartz-test": "/quartz-test/static-1.858",
  "quartz-tracking": "/quartz-tracking/static-1.562",
  "trellis-components": "/trellis-components/static-1.2217",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.186",
  "bender-build-tools": "/bender-build-tools/static-1.3297",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21866",
  "ContentUtils": "/ContentUtils/static-1.68715",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13148",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2616",
  "breeze-engine-core": "/breeze-engine-core/static-1.412",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.263",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40216",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13293",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14764",
  "ExportDialog": "/ExportDialog/static-6.10499",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41608",
  "reporting-snowflake": "/reporting-snowflake/static-1.56673",
  "reporting-ui-components": "/reporting-ui-components/static-2.65326",
  "reporting-visualizations": "/reporting-visualizations/static-1.60131",
  "trellis-theming": "/trellis-theming/static-1.1060",
  "ui-addon-teams": "/ui-addon-teams/static-1.21706",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.194",
  "magpie-lib": "/magpie-lib/static-1.5630",
  "navigation-components": "/navigation-components/static-1.18306",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1134",
  "magpie-types": "/magpie-types/static-1.5090",
  "simple-logging-lib": "/simple-logging-lib/static-1.3168",
  "ai-studio-lib": "/ai-studio-lib/static-1.11968",
  "app-governance-lib": "/app-governance-lib/static-1.1931",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10632",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8127",
  "ui-product-approvals": "/ui-product-approvals/static-1.28633",
  "ui-tool-access": "/ui-tool-access/static-1.10267",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9442",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5884",
  "usage-tracker-public": "/usage-tracker-public/static-1.7278",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3674",
  "persist-promise": "/persist-promise/static-1.3819",
  "reference-resolvers": "/reference-resolvers/static-1.8294",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4043",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.456",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3133",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3113",
  "atom": "/atom/static-1.5194",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6099",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1662",
  "crm-component-utils": "/crm-component-utils/static-1.39394",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6009",
  "customer-data-properties": "/customer-data-properties/static-1.51977",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7013",
  "property-value-citations": "/property-value-citations/static-1.2591",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8216",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9186",
  "navigation-messaging": "/navigation-messaging/static-1.7633",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10259",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4934",
  "content-icons-ui": "/content-icons-ui/static-1.2260",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9944",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7366",
  "crm-message-bus": "/crm-message-bus/static-1.43297",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22651",
  "events-data-lib": "/events-data-lib/static-1.352",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4840",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4091",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6918",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1100",
  "onboarding-tours": "/onboarding-tours/static-1.16831",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14023",
  "academy-common-lib": "/academy-common-lib/static-1.14224",
  "content-assistance-lib": "/content-assistance-lib/static-1.7948",
  "dashboard-lib": "/dashboard-lib/static-1.82001",
  "file-manager-components": "/file-manager-components/static-1.23961",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18745",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18583",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18575",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20043",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8823",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4878",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11186",
  "user-context": "/user-context/static-1.5228",
  "growth-payments-core": "/growth-payments-core/static-1.25729",
  "reporting-plugins": "/reporting-plugins/static-1.10512",
  "reporting-reports": "/reporting-reports/static-1.67733",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.845",
  "nest": "/nest/static-1.351",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10746",
  "framework-listing-lib": "/framework-listing-lib/static-2.29030",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30986",
  "apps-service-types": "/apps-service-types/static-1.3919",
  "oauth-service-types": "/oauth-service-types/static-1.4372",
  "react-dnd-compat": "/react-dnd-compat/static-1.4733",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.528",
  "onboarding-scopes": "/onboarding-scopes/static-1.6579",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5045",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7761",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15069",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3673",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9604",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6102",
  "signup-constants": "/signup-constants/static-1.19140",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8176",
  "card-properties-lib": "/card-properties-lib/static-1.44550",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37422",
  "crm-actions": "/crm-actions/static-1.6459",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43950",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9588",
  "customer-data-tracking": "/customer-data-tracking/static-1.7006",
  "hs-resources": "/hs-resources/static-1.294",
  "pulse": "/pulse/static-1.723",
  "calling-global-api": "/calling-global-api/static-1.64921",
  "calling-internal-common": "/calling-internal-common/static-1.31429",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66303",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58597",
  "commerce-products-lib": "/commerce-products-lib/static-1.10008",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3885",
  "crm-links": "/crm-links/static-1.6426",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4224",
  "external-options-client-types": "/external-options-client-types/static-1.4214",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4305",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.752",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3778",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49157",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4053",
  "smart-property-lib": "/smart-property-lib/static-1.7850",
  "tiered-pricing": "/tiered-pricing/static-1.1533",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11109",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.132",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1175",
  "growth-data-modal": "/growth-data-modal/static-1.5626",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3184",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2261",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.897",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7751",
  "academy-service-client": "/academy-service-client/static-1.3803",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39460",
  "FileManagerLib": "/FileManagerLib/static-1.39601",
  "SafeStorage": "/SafeStorage/static-1.4517",
  "video-embed": "/video-embed/static-1.36158",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28891",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11666",
  "video-data-lib": "/video-data-lib/static-1.35324",
  "content-media-capture": "/content-media-capture/static-1.4877",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23831",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10006",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24640",
  "viral-links-lib": "/viral-links-lib/static-1.7187",
  "data-token-picker": "/data-token-picker/static-1.16625",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.349",
  "timezone-utils": "/timezone-utils/static-2.5362",
  "seat-types-lib": "/seat-types-lib/static-1.280",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17863",
  "ui-addon-opt": "/ui-addon-opt/static-4.8480",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9454",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25692",
  "framework-data-table": "/framework-data-table/static-2.12193",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6984",
  "nudge-client-utils": "/nudge-client-utils/static-1.2838",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1241",
  "switchboard-lib": "/switchboard-lib/static-1.342",
  "app-users-service-client": "/app-users-service-client/static-1.5728",
  "app-users-service-types": "/app-users-service-types/static-1.5136",
  "mini-checkout-client": "/mini-checkout-client/static-1.27101",
  "onboarding-utils": "/onboarding-utils/static-1.5477",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2062",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28876",
  "edison-service-client-types": "/edison-service-client-types/static-1.508",
  "crm_data": "/crm_data/static-4.92344",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46345",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16968",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4379",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1263",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19481",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18834",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10695",
  "crm-fe-perf": "/crm-fe-perf/static-1.23021",
  "event-emitter": "/event-emitter/static-1.1068",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.226",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31436",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11154",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6662",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1450",
  "commerce-permissions": "/commerce-permissions/static-1.895",
  "products-iframe-lib": "/products-iframe-lib/static-1.8262",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10643",
  "data-agent-kit": "/data-agent-kit/static-1.399",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10344",
  "policy-lib": "/policy-lib/static-1.6904",
  "react-tinymce": "/react-tinymce/static-1.55561",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10407",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54687",
  "tinymce-plugins": "/tinymce-plugins/static-1.57801",
  "tinymce-themes": "/tinymce-themes/static-1.56657",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2173",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2289",
  "user-context-client": "/user-context-client/static-1.4698",
  "audio-components": "/audio-components/static-1.6104",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37112",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4655",
  "video-components": "/video-components/static-1.13668",
  "outpost": "/outpost/static-1.4287",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6697",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12681",
  "content-media-compositions": "/content-media-compositions/static-2.16688",
  "media-bridge-lib": "/media-bridge-lib/static-1.19138",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4544",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6324",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5200",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3712",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21891",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3969",
  "ts-utils-lib": "/ts-utils-lib/static-1.292",
  "crm-export-dialog": "/crm-export-dialog/static-1.6404",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6560",
  "crm-view-components": "/crm-view-components/static-1.636",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7450",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2595",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2914",
  "whisper-core-api": "/whisper-core-api/static-1.6876",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15126",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5812",
  "settings-content-modals": "/settings-content-modals/static-1.46420",
  "crm_universal": "/crm_universal/static-1.22226",
  "customer-data-email": "/customer-data-email/static-1.18252",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37516",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39845",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12641",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55118",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21792",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18291",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72419",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5459",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9856",
  "utility-belt": "/utility-belt/static-1.2650",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23268",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7726",
  "customer-data-rte": "/customer-data-rte/static-1.33310",
  "cv-backend-services": "/cv-backend-services/static-1.1561",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5966",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5225",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38509",
  "trials-service-types": "/trials-service-types/static-1.4002",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36227",
  "sales-views-client-types": "/sales-views-client-types/static-1.4376",
  "hub-http-contrib": "/hub-http-contrib/static-1.3162",
  "interframe": "/interframe/static-3.4879",
  "tinymce-data": "/tinymce-data/static-1.40772",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5329",
  "layout-dnd-components": "/layout-dnd-components/static-1.12682",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11657",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15714",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9141",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7724",
  "social-insights-client-types": "/social-insights-client-types/static-1.22353",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4293",
  "checkout-sdk": "/checkout-sdk/static-3.23944",
  "company-details-components": "/company-details-components/static-1.6317",
  "payment-method-components": "/payment-method-components/static-1.6988",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14732",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3583",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3641",
  "access-control-lib": "/access-control-lib/static-1.10555",
  "EmailComponents": "/EmailComponents/static-1.55102",
  "EmailData": "/EmailData/static-1.53779",
  "redux-less": "/redux-less/static-2.9601",
  "sequences-lib": "/sequences-lib/static-1.8247",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10469",
  "products-ui-components": "/products-ui-components/static-1.40526",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7265",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55134",
  "commerce-products-api": "/commerce-products-api/static-1.2471",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57192",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103097",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81140",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28576",
  "ContentData": "/ContentData/static-1.68790",
  "layout-data-lib": "/layout-data-lib/static-1.9982",
  "checkout-service-types": "/checkout-service-types/static-1.3884",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.812",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4056",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4109",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.676",
  "pricing-pages-api": "/pricing-pages-api/static-1.14597",
  "ContentComponents": "/ContentComponents/static-2.71671",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10439",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1988",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46620",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1482",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19230",
  "automation-ui-types": "/automation-ui-types/static-1.20148",
  "messaging-types-lib": "/messaging-types-lib/static-1.46357",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4623",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8104",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.654",
  "price-books-api": "/price-books-api/static-1.1254",
  "price-books-components": "/price-books-components/static-1.1312",
  "property-description-translator": "/property-description-translator/static-1.3960",
  "ramp-editor": "/ramp-editor/static-1.467",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3700",
  "totals-ui-components": "/totals-ui-components/static-1.23922",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9410",
  "advanced-menus-core": "/advanced-menus-core/static-1.15332",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12243",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34364",
  "segments-query-core": "/segments-query-core/static-1.1539",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6064",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7457",
  "data-token-views": "/data-token-views/static-1.16606",
  "forms-utils-lib": "/forms-utils-lib/static-1.12811",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13279",
  "simple-menus-core": "/simple-menus-core/static-1.15331",
  "simple-menus-lib": "/simple-menus-lib/static-1.16848",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7004",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.16",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7630",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77435",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4042",
  "web-interactives-components": "/web-interactives-components/static-1.13976",
  "web-interactives-data": "/web-interactives-data/static-1.13977",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.931",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1101",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1096",
  "line-items-api": "/line-items-api/static-1.869",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3905",
  "FireAlarmUi": "/FireAlarmUi/static-1.4595",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4256",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22084",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21547",
  "data-studio-ubb": "/data-studio-ubb/static-1.3067",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27294",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58199",
  "content-management-data-lib": "/content-management-data-lib/static-1.5619",
  "copilot-plugins": "/copilot-plugins/static-1.11413",
  "cta-picker": "/cta-picker/static-1.36714",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3427",
  "editor-components": "/editor-components/static-1.13407",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8574",
  "error-messaging-js": "/error-messaging-js/static-1.5312",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86138",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10765",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1863",
  "smart-content-core": "/smart-content-core/static-1.42768",
  "smart-content-lib": "/smart-content-lib/static-1.43421",
  "social-composer-lib": "/social-composer-lib/static-1.59577",
  "structured-content-lib": "/structured-content-lib/static-1.25510",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53570",
  "tinymce-copilot": "/tinymce-copilot/static-1.16755",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8061",
  "automation-ui-routing": "/automation-ui-routing/static-1.21505",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5733",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42458",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3311",
  "reporting-enablement": "/reporting-enablement/static-1.23332",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21857",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2996",
  "forms-ai-lib": "/forms-ai-lib/static-1.4509",
  "codemirror-dlb": "/codemirror-dlb/static-1.58994",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6554",
  "report-customization-components": "/report-customization-components/static-1.13499",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13345",
  "reporting-filters": "/reporting-filters/static-1.620",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2095"
}
};
